import {Component, OnInit, OnDestroy, ViewChild, Input, EventEmitter} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../../srvs/lookup";
import {UsageFilter} from "../../usage/usage.filter";
import {SettingsPersistenceService} from "../../services/settings-persistence.service";
import {TicketFilter} from "./ticket.filter";

@Component({
  selector: 'micro-tickets',
  templateUrl: './tickets.component.html'
})
export class TicketsComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:TicketFilter = new TicketFilter();

  dateRangeSelector:UsageFilter = new UsageFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;
  outageNow:Date = new Date();

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();
  private refreshTimer: any;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              public lookupService:LookupService) {
  }

  ngOnInit() {

    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.acc.tickets");
    this.pageSettings
      .setDateRangeSelector(this.dateRangeSelector) // if needed
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .init();

    if (this.filter.status === undefined) {
      this.filter.status = '0'
    }

    this.reloadDebouncer.pipe(debounceTime(100)).subscribe(change => {
      this.reload();
    });

    this.dateRangeSelector.anyChange.pipe().pipe(debounceTime(500)).subscribe(change => {
      this.reloadDebounced();
    });
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reloadDebounced();
    });

    this.refreshTimer = setInterval(()=> {
      if (this.pageSettings.generalSettings.autoRefresh) {
        this.reloadDebounced();
      }
    }, 10000);
  }

  ngOnDestroy() {
    clearInterval(this.refreshTimer);
  }

  reloadDebounced() {
    this.reloadDebouncer.emit();
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      ;

    if (!this.dateRangeSelector.fromInfinite) {
      params = params.set('from', '' + this.dateRangeSelector.from);
    }
    if (!this.dateRangeSelector.untilInfinite) {
      params = params.set('until', '' + this.dateRangeSelector.until);
    }

    this.http.get(`${this.env.e.url}/task/tickets`, {params: params}).subscribe(
      data => {
        this.outageNow = new Date();
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  outageHours(startTime:string):number {
    const diff =  this.outageNow.getTime() - new Date(startTime).getTime();
    return diff / 3600000;
  }

  outageStr(startTime:string): string {
    const diff =  this.outageNow.getTime() - new Date(startTime).getTime();
    const minutesTotal = Math.floor(diff / 60000);
    const days = Math.floor(minutesTotal / (60 * 24));
    const hours = Math.floor((minutesTotal % (60 * 24)) / 60);
    const minutes = minutesTotal % 60;

    return `${days}d ${hours}h ${minutes}m`;
  }

  formatTicketNumber(ticketNumber:number): string {
    return `NOC/${String(ticketNumber).padStart(6, '0')}`;
  }

  protected getSiteSiteName(option: any) {
    if (!option) return "undefined";
    return `${option.name} (${option.siteId})`;
  }
}
